export default {
  ProductionURL: 'https://safetychampion.online',
  Dev2URL: 'https://dev2.dev.safetychampion.tech',
  Dev1URL: 'https://dev1.dev.safetychampion.tech',
  LocalURL: 'http://localhost',
  AdaDev: 'https://adadev.dev.safetychampion.tech',
};
